// extracted by mini-css-extract-plugin
export default {"qrCode":"QrCode_qrCode__upEEx","qrCodeDesc":"QrCode_qrCodeDesc__cj+P+"};